import PageComponent from '../base/PageComponent';
import 'slick-carousel';
import 'whatwg-fetch';
import '../libs/popup';

export default class HeroModule extends PageComponent
{
    init() {
        this.setupCarousel();
        this.addEvent('form', 'submit', e => this.ajaxSubmit(e));
        this.addEvent('.video-play', 'click', e => this.playVideo(e));
        this.addEvent('.close-popup', 'click', e => this.pauseVideo(e));
    }

    ajaxSubmit(e){
        e.preventDefault();
        let url = e.target.getAttribute('action'),
            formData = new FormData(e.target),
            headers = new Headers(),
            self = this;

        headers.append("X-Requested-With", "XMLHttpRequest");

        fetch(url, {
            method: 'POST',
            headers: headers,
            body: formData
        }).then(response => {
            return response.json();
        }).then(json => {
            let status = json.Status;
            if(status == 1){
                e.target.style.display = 'none';
                self.childElements('.success')[0].style.display = 'block';
            }
        });
    }

    videoPopup(e) {
        let video = $(e.target).closest('.hero-item').find('video').clone();

        video.popup({
            popupHTML: '<div class="popup hero-video-popup"><div class="popup-content"></div></div>',
            overlayHTML: '<div class="popup-overlay image-modal-overlay"><div class="close-popup icon-close" title="Close"></div></div>',
            fadeIn: false,
            onShow: video.get(0).play()
        });
    }

    playVideo(e){
        this.videoPopup(e);
    }

    pauseVideo(e){
        $('.video-play').show();
    }

    setupCarousel() {
        if (this.getSlides() > 1) {
            this.childElements('.hero-item-container').slick({
                slide: '.hero-item',
                autoplay: true,
                autoplaySpeed: 5000,
                speed: 1000,
                adaptiveHeight: false,
                dots: true,
                appendDots: $('.slider'),
                dotsClass: 'slick-dots slick-dots--light',
                customPaging: function (slider, i) {
                    var thumb = $(slider.$slides[i]).data('thumb');
                    return '<span></span>';
                },
                slidesToShow: 1,
                infinite: false,
                arrows: false,
                responsive: [
                    {
                        breakpoint: 1090,
                        settings: {
                            arrows: false
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            arrows: false,
                            dotsClass: 'slick-dots slick-dots--grey'
                        }
                    }
                ]
            });
        }
        //this.addEvent('.next', 'click', e => this.onCarouselNext(e));
    }

    getSlides(){
        return this.childElements('.hero-item').length;
    }

    //onCarouselNext(e) {
    //    let button = $(e.target);
    //    this.element.owlCarousel('goto', 5);
    //}

    //onThumbClick(e) {
    //    e.preventDefault();
    //
    //    let thumb = $(e.target);
    //
    //    var sliderID = thumb.closest('.imageModalModule').attr('id'),
    //        slider = $('#' + sliderID + ' .image-modal-popup-container').clone(),
    //        selectedSlide = thumb.data('slick-index'),
    //        id = thumb.closest('.imageModalModule').attr('id'),
    //        numbOfSlide = thumb.closest('.image-modal-container').find('.thumb').length;
    //}
}


// WEBPACK FOOTER //
// ./javascript/modules/HeroModule.js